import React, { useState } from "react";
import { format } from "date-fns";
import {
  IonItem,
  IonLabel,
  IonButton,
} from "@ionic/react";
import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import "../theme/AppStyles.css";
import { SchedulerJobCards } from "./SchedulerJobCards";


export const SpecificScheduler: React.FC<{schedulerUID: string, schedulerName: string, openJobs: number, filledJobs: number, pastJobs: number}> = ({schedulerUID, schedulerName, openJobs, filledJobs, pastJobs }) => {
  const [jobCategoryFilter, setJobCategoryFilter] = React.useState<string>("");
  const [jobsList, setJobsList] = useState([""]);

  // console.log("SpecificScheduler");

  const setupJobDataStructure = (jobObj: any, jobDocId: string) => {

    return {
      JobDocId: jobDocId,
      Company: jobObj.jobInfo.core.company || "",
      Pay: jobObj.jobInfo.core.pay || "",
      DateDay: format(
          new Date(jobObj.jobInfo.core.dateTimeStart.substring(0, 19)),
          "M/d/yy") || "",
      StartDateTime: format(
        new Date(jobObj.jobInfo.core.dateTimeStart.substring(0, 19)),
        "h:mma") || "",
      FinishDateTime: format(
          new Date(jobObj.jobInfo.core.dateTimeFinish.substring(0, 19)),
          "h:mma") || "",
      ShiftIdentifier: jobObj.jobInfo.core.shiftIdentifier || "",
      PaidWerkers: jobObj.jobInfo.status.isPaidWerkers,
      IsPaidJob: jobObj.jobInfo.status.isPaidJob,
      JobCancelledByScheduler: jobObj.jobInfo.status.jobCancelledByScheduler,
      IsNewMessage: jobObj.jobInfo.status.isNewMessage,
      IsRead: jobObj.jobInfo.status.isRead,
      Location: jobObj.jobInfo.core.location,
      NumberOfJobSlots: jobObj.jobInfo.core.numJobSlots,
      RemainingSlots: 0,
    };
  };

  const handleClearJobs = () => {
    // console.log("Clear Jobs Clicked");
    setJobCategoryFilter("");
  };
  
  const handleJobSelection = async (e: any) => {
    const jobsCategory = e.currentTarget.getAttribute("data-jobs-type");
    // console.log("Job Selection Clicked for Scheduler UID:", jobsCategory, schedulerUID);

    const tempJobsList: Array<any> = [];
    const jobQuery = query(
      collectionGroup(db, "jobsDocs"),
      where("docStamp.userInfoFrom.uid", "==", schedulerUID),
      where("docStamp.userInfoTo.uid", "==", schedulerUID),
      where("jobInfo.status.jobStatusSched", "==", jobsCategory)
    );
    const snapshot = await getDocs(jobQuery);

    snapshot.forEach((doc) => {
      const jobData = setupJobDataStructure(doc.data(), doc.id);
      tempJobsList.push(jobData);
    });
    setJobsList(tempJobsList);
    setJobCategoryFilter(jobsCategory);
  };

  
  return (
    <React.Fragment>
       <IonItem 
        key={1}
      >
        <IonLabel className="labelo">
          <h2>
            {schedulerName}
          </h2>
          <h2>{schedulerUID}</h2>
          <h2 data-jobs-type="Open" onClick={handleJobSelection}>jobs Open: {openJobs}</h2>
          {/* <h2 onClick={handleOpenJobs}>jobs Open: {openJobs}</h2> */}
          <h2 data-jobs-type="Filled" onClick={handleJobSelection}>jobs Filled: {filledJobs}</h2>
          <h2 data-jobs-type="Past" onClick={handleJobSelection}>jobs Past: {pastJobs}</h2>
          <h2>Total Jobs: {openJobs + filledJobs + pastJobs}</h2>
          <br></br>
        </IonLabel>
      </IonItem>

      {jobCategoryFilter !== "" && 

        <><IonButton size="small" color="medium"
          onClick={handleClearJobs}
        >
          Clear Jobs
        </IonButton>
        <h2>Displaying {jobCategoryFilter} Jobs for {schedulerName}</h2>
        <SchedulerJobCards jobsArray={jobsList} />
        </>
      }
    </React.Fragment>
  );
}
